module.exports = __webpack_public_path__ + "static/media/mixedevent.112b6021.jpeg";